<template>
  <el-dialog title="详情"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-tabs v-model="activeName">
      <el-tab-pane v-if="false"
                   label="基本信息"
                   name="5">
        <el-card shadow="never">
          <div>
            <p class="card-text">
              <i class="el-icon-discount ftblue mr-10"></i>
              CSN：{{ actData.info.sn }}
            </p>
            <p class="card-text">
              <i class="el-icon-discount ftblue mr-10"></i>
              名称：{{ actData.info.name }}
            </p>
            <p class="card-text">
              <i class="el-icon-discount ftblue mr-10"></i>
              在线状态：
              <el-tag v-if="actData.info.online === '1'"
                      type="success"> 在线 </el-tag>
              <el-tag v-else
                      type="danger"> 离线 </el-tag>
            </p>
            <p class="card-text">
              <i class="el-icon-discount ftblue mr-10"></i>
              激活状态：
              <el-tag v-if="actData.info.activated === '1'"
                      type="success"> 已激活 </el-tag>
              <el-tag v-else
                      type="danger"> 未激活 </el-tag>
            </p>
            <p class="card-text">
              <i class="el-icon-discount ftblue mr-10"></i>
              ClientID：{{ actData.info.clientid }}
            </p>
            <p class="card-text">
              <i class="el-icon-discount ftblue mr-10"></i>
              区域：{{ actData.info.area_id }}
            </p>
            <p class="card-text">
              <i class="el-icon-discount ftblue mr-10"></i>
              设备数量：{{ actData.info.lock_count }}
            </p>
            <p class="card-text">
              <i class="el-icon-discount ftblue mr-10"></i>
              注册时间：{{ actData.info.regtime }}
            </p>
            <p class="card-text">
              <i class="el-icon-discount ftblue mr-10"></i>
              备注：{{ actData.info.remarks }}
            </p>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="通道1"
                   name="0">
      </el-tab-pane>
      <el-tab-pane label="通道2"
                   name="1">
      </el-tab-pane>
      <el-tab-pane label="通道3"
                   name="2">
      </el-tab-pane>
      <el-tab-pane label="通道4"
                   name="3">
      </el-tab-pane>
    </el-tabs>
    <el-card v-if="activeName !== '5'"
             shadow="never">
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>频率：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].Frequency : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>空中速率(kbps)：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].SpeedRate : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>发射功率(dBm)：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].RadioPower : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>串口速率(bps)：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].ComSpeed : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>串口校验方式：{{ actData.lora[Number(activeName)] ? comCheckData[actData.lora[Number(activeName)].ComCheck] : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>唤醒周期(ms)：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].AwakenTime : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>触发延时(ms)：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].TriggerDelay : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>载波监听时间(ms)：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].CarrierTime : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>无线数据包长(Byte)：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].WirelessPkgLen : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>硬件地址：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].DeviceAddr : '' }}</p>
      <!-- <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>目标地址：{{ actData.lora[Number(activeName)] ? actData.lora[Number(activeName)].TargetAddr : '' }}</p> -->
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
        定长帧模式：{{ actData.lora[Number(activeName)] ? (actData.lora[Number(activeName)].FB_FixedFrame === '1' ? '是' : '否') : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
        场强检测：{{ actData.lora[Number(activeName)] ? (actData.lora[Number(activeName)].FB_FieldStrength === '1' ? '是' : '否') : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
        载波侦听：{{ actData.lora[Number(activeName)] ? (actData.lora[Number(activeName)].FB_CarrierSense === '1' ? '是' : '否') : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
        硬件地址使能：{{ actData.lora[Number(activeName)] ? (actData.lora[Number(activeName)].FB_DevAddrEnable === '1' ? '是' : '否') : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
        发送源地址使能：{{ actData.lora[Number(activeName)] ? (actData.lora[Number(activeName)].FB_SrcAddrEnable === '1' ? '是' : '否') : '' }}</p>
      <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
        低功耗休眠：{{ actData.lora[Number(activeName)] ? (actData.lora[Number(activeName)].FB_LowPowerSleep === '1' ? '是' : '否') : '' }}</p>
    </el-card>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="handleCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: String
    }
  },
  data() {
    return {
      showModal: this.isShow,
      comCheckData: { '00': '无校验', '01': '奇校验', '02': '偶校验' },
      activeName: '0',
      actData: {
        info: {
          activated: '',
          area_id: '',
          clientid: '',
          id: '',
          ip: '',
          lock_count: '',
          name: '',
          online: '',
          regtime: '',
          remarks: '',
          sn: ''
        },
        lora: [
          {
            AwakenTime: '',
            CarrierTime: '',
            ComCheck: '',
            ComSpeed: '',
            DeviceAddr: '',
            FB_CarrierSense: '',
            FB_DevAddrEnable: '',
            FB_FieldStrength: '',
            FB_FixedFrame: '',
            FB_LowPowerSleep: '',
            FB_SrcAddrEnable: '',
            Frequency: '',
            RadioPower: '',
            SpeedRate: '',
            TriggerDelay: '',
            WirelessPkgLen: '',
            channel: '',
            id: '',
            sn: ''
          }
        ]
      }
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      fetch.getGateInfo({ id: this.data }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.actData = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style></style>
